import { AgsEnterFreespinsState } from "ags/state-machine/states/ags-enter-freespins-state";
import { Services } from "appworks/services/services";
import { PromptContentSubcomponent } from "appworks/components/prompt/prompt-content-subcomponent";
import { Components } from "appworks/components/components";
import { PromptComponent } from "appworks/components/prompt/prompt-component";
import { gameState } from "appworks/model/game-state";
import { TranslationsService } from "appworks/services/translations/translations-service";
import { Contract } from "appworks/utils/contracts/contract";
import { Parallel } from "appworks/utils/contracts/parallel";
import { Sequence } from "appworks/utils/contracts/sequence";
import { MatrixComponent } from "slotworks/components/matrix/matrix-component";
import { staggerSceneChanges } from "util/stagger-scene-changes";
import { SpinRecord } from "slotworks/model/gameplay/records/spin-record";
import { WaysResult } from "slotworks/model/gameplay/records/results/ways-result";
import { Point } from "appworks/utils/geom/point";
import { deepClone, wrapIndex } from "appworks/utils/collection-utils";
import { reelPaddings } from "util/reel-paddings";
import { FreespinWinResult } from "slotworks/model/gameplay/records/results/freespin-win-result";
import { Layers } from "appworks/graphics/layers/layers";
import { LayerNames } from "game-layers";
import { Model } from "appworks/model/model";
import { SoundService } from "appworks/services/sound/sound-service";

export class ThemeEnterFreespinsState extends AgsEnterFreespinsState {
    protected prompt?: PromptContentSubcomponent;

    public onEnter(): void {
        this.setupMatrix();
        this.changeBackground();
        super.onEnter();
    }

    public onSkip(): void {
        Services.get(SoundService).customEvent("stop_bonus_bell");
        Components.get(PromptComponent).forceComplete();
    }

    public complete() {
        super.complete();
    }

    protected setupMatrixComponent(): void {
        // Done in setupMatrix() because we want the matrix to change while the wipe
        // animation is playing, not in super.onEnter().
    }

    protected setupMatrix(): void {
        Components.get(MatrixComponent).change("freespins", [3, 3, 3, 3]);
        staggerSceneChanges(["Jackpots", "Banners", "MatrixForeground", "MatrixBackground", "SymbolAnimations"], "freespins");

        const record = gameState.getCurrentGame().getCurrentRecord() as SpinRecord;
        Components.get(MatrixComponent).jumpToGrid(this.getSeededPaddedReels(record));
    }
    protected onShowImplementation = () => {
        this.prompt.setClickToSkip(true);
        const record = gameState.getCurrentGame().getCurrentRecord();
        const congratulationsSprite = Layers.get(LayerNames.Prompts).getSprite("winCong");
        congratulationsSprite.visible = Model.read().settings.language === "en";

        const congratulationsText = Layers.get(LayerNames.Prompts).getText("congratulationsText");
        congratulationsText.text = Services.get(TranslationsService).get("pmt.con");
        congratulationsText.visible = !congratulationsSprite.visible;
        this.prompt.setText("winMessage", Services.get(TranslationsService).getFirstValid(["free_spins_awarded"], { VALUE: record.getFreespinsWon() }));
    }
    protected showPrompt(prompt?: PromptContentSubcomponent): void {

        this.prompt = new PromptContentSubcomponent(["freespinswin"], Infinity, null, this.onShowImplementation);

        Components.get(PromptComponent)
            .showPrompt(this.prompt)
            .then(() => this.complete());
    }

    /**
     * I've stored a few sets of valid reel paddings (generated by the gb-pad-grid-supplement) and pad the base reels
     * with one of them, chosen based on the triggering bonus symbol positions, so that the padding is consistent
     * across recovery before the blockers appear
     */
    protected getSeededPaddedReels(record: SpinRecord): string[][] {
        const result = record.getFirstResultOfType(FreespinWinResult).linkedResult as WaysResult;

        let rnd = 0;
        result.positions.forEach((pos: Point) => {
            rnd += pos.x + pos.y;
        });

        const reelPadding = deepClone(wrapIndex(rnd, reelPaddings));

        const paddedReels = reelPadding.map((reel: string[], index: number) => {
            return reel.concat(record.grid[index]);
        });

        return paddedReels;
    }
}
